import { observer } from 'mobx-react';
import Image from '../Image';
import SizedImage from '../SizedImage';
import { proportionalImageWidth } from '../SizedImage/SizedImageStore/Types';
import { cn } from '@execonline-inc/execonline-ui';

interface Props {
  href: string;
  alt: string;
  height: number;
  className?: string;
}

function ProportionalImage({ href, alt, height, className }: Props) {
  return (
    <SizedImage uri={href}>
      {(src, dimensions) => (
        <Image
          style={{ height, width: proportionalImageWidth(dimensions, height) }}
          className={cn('max-w-full object-contain', className)}
          src={src}
          alt={alt}
        />
      )}
    </SizedImage>
  );
}

export default observer(ProportionalImage);
